import moment from 'moment';

export default [
  {
    name: 'Name',
    field: 'name',
    width: 'large',
    prepData: mem => {
      return `${mem.name}`;
    },
  },
  {
    name: 'Email',
    field: 'email',
    width: 'large',
  },
  {
    name: 'Role',
    field: 'role',
    width: 'large',
  },
];



/** WEBPACK FOOTER **
 ** ./src/tables/managers.js
 **/